module.exports = __webpack_public_path__ + "images/emoji_58b6efa6063d0135fb121bedcca7774ab.svg";